import React from "react";


export const CkEditorColumnFormatter = (description) => (
    <>
        {<div dangerouslySetInnerHTML={{ __html: description }} />}
    </>
);
